"use client"
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import "./accordion.scss";

const Accordion = ({ items = [] }) => {
  const [expandedAccordion, setExpandedAccordion] = useState("delivery");

  const toggleAccordion = (id) => {
    setExpandedAccordion(expandedAccordion === id ? null : id);
  };

  const accordionItems = [
    {
      id: "delivery",
      title: "DELIVERY & RETURN",
      content: ["All orders would take a minimum of 2 to 3 weeks for delivery."],
    },
    {
      id: "care",
      title: "CARE INSTRUCTIONS",
      content: ["Dry clean only. Store in garment bag."],
    },
    {
      id: "disclaimer",
      title: "DISCLAIMER",
      content: [
        "All sales are final, with no REFUND OR EXCHANGE POLICY.",
        "Any defects need to be notified within 5 days to be acknowledged.",
        "Length will vary according to the design.",
        "Actual color outfit may vary due to lighting and display colors of your device.",
        "No exchange or refund.",
        "Colors may vary as all pieces are hand dyed.",
        "Laces & trimmings may vary depending on availability.",
      ],
    },
  ];

  return (
    <div className="accordions-container">
      {accordionItems.map((item) => (
        <div key={item.id} className="accordion-item">
          <button
            className="accordion-header"
            onClick={() => toggleAccordion(item.id)}
          >
            <span className="accordion-title">{item.title}</span>
            <MdAdd
              className={`accordion-icon ${expandedAccordion === item.id ? "expanded" : ""
                }`}
              size={20}
            />
          </button>
          {expandedAccordion === item.id && (
            <div className="accordion-content">
              {item.content.map((text, index) => (
                <p key={index} className="mb-3 text-gray-700 leading-7">
                  - {text}
                </p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
